<template>
  <button
    class="form-button"
    :class="buttonClassList"
    :disabled="isBusy || isDisabled"
  >
    <BusyIndicator v-if="isBusy" />
    <slot v-else></slot>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'

const props = defineProps({
  isPrimary: {
    type: Boolean,
    default: true,
  },

  isSecondary: {
    type: Boolean,
    default: false,
  },

  isBusy: {
    type: Boolean,
    default: false,
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  isSmall: {
    type: Boolean,
    default: false,
  },
})

const buttonClassList = computed<object>((): object => {
  return {
    'is-primary': !props.isSecondary,
    'is-secondary': props.isSecondary && !props.isPrimary,
    'is-small': props.isSmall,
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:color';
@import 'src/assets/scss/controls';

.form-button {
  @include control-style-base;

  text-align: center;
  cursor: pointer;
  user-select: none;

  &:focus-visible,
  &:hover {
    opacity: 0.7;
  }

  &.is-primary {
    background-color: $color-accent;
    color: $color-text-inverted;

    &:disabled {
      background-color: color.adjust(
        $color-accent,
        $saturation: -100%,
        $lightness: 24%
      );
      cursor: not-allowed;
    }
  }

  &.is-secondary {
    background-color: $color-background;
    color: $color-accent;
    border: $border-width solid $color-accent;
  }

  &.is-small {
    min-width: auto;
    font-size: 0.75em;
    padding: 0.5em;
  }
}
</style>
